import { Button, Typography, Spin, Carousel } from "antd";
import React, { useState, useEffect, useRef } from "react";
import useFormContext from "../../hooks/useFormContext";
import { getMinFromBuilding } from "../../utils/buildingCalculations";
import { RightCircleOutlined, LeftCircleOutlined } from "@ant-design/icons";
import {
  assignAtrialAndRecalculate,
  getDesignsWithAreaLessThanOrEqualToFloorOne,
  getMinimumAreas,
  isFloorOne,
  addDescriptionToDesignGroup,
  getColumnDimensionsFromFloorOne,
  getDesignWithColumnLengthLessThanOrEqualToFloorOne,
  assignColumnDimensionsAndRecalculate,
} from "../../utils/floorCalculations";
import OptimizedSummary from "./OptimizedSummary";
import TempTable from "./TempTable";

const { Title } = Typography;
const FixedColumnsSecondStage = () => {
  const [showTable, setShowTable] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [optimalFloorOne, setOptimalFloorOne] = useState({});
  const [temp1, setTemp1] = useState([]);
  const [temp2, setTemp2] = useState([]);
  const [currentGroupIndex, setCurrentGroupIndex] = useState(0);
  const carouselRef = useRef();
  const {
    buildingLevelValuesSecondStage,
    concreteInfo,
    steel,
    optimalDesigns,
    setOptimalDesigns,
    floorLevelValuesSecondStage,
  } = useFormContext();
  const [constantConcreteOptimization, setConstantConcreteOptimization] =
    useState([]);

  useEffect(() => {
    optimize();
    const timer = setTimeout(() => {
      setIsLoading(false);
      setShowTable(true);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  const optimize = () => {
    setIsLoading(true);
    const temp1 = []; // temp tables to be displayed
    const temp2 = [];

    const floorOne = floorLevelValuesSecondStage.find((floor) => isFloorOne(floor.floor)); // extract first floor object
    const optimalFloorOne = getSmallestFromFloorX(
      floorOne.combinations,
      floorOne.floor
    );
    const smallestDesigns = [];

    console.log("Lowest from floor one ", optimalFloorOne);
    smallestDesigns.push(optimalFloorOne);

    setOptimalFloorOne(optimalFloorOne); // doing it for temp table
    // get the min area which will be used to compare for other floors
    const minAreas = getMinimumAreas(optimalFloorOne);

    const minDimensions = getColumnDimensionsFromFloorOne(optimalFloorOne);

    console.log("Min col dimensions from floor one are ", minDimensions);
    floorLevelValuesSecondStage.forEach((element) => {
      if (!isFloorOne(element.floor)) {
        // from other floors, get designs whose area less than floor one design
        const eligibleDesigns = getDesignsWithAreaLessThanOrEqualToFloorOne(
          minAreas,
          element
        );
        console.log("Old eligible items are ", eligibleDesigns);
        const eligibleNewDesigns =
          getDesignWithColumnLengthLessThanOrEqualToFloorOne(
            element,
            minDimensions
          );
        temp1.push(eligibleNewDesigns);

        console.log("New eligible items are ", eligibleNewDesigns);
        // now for these floors, recalculate the properties
        // const newCombs = assignAtrialAndRecalculate(
        //   minAreas,
        //   eligibleDesigns,
        //   concreteInfo,
        //   steel
        // );

        // re-calculate with new but old method
        const newNewCombs = assignColumnDimensionsAndRecalculate(
          minDimensions,
          eligibleNewDesigns,
          concreteInfo,
          steel
        );
        temp2.push(newNewCombs);
        console.log("New calculations are ", newNewCombs);

        // now get the design with smallest iTotal
        //const smallestDesign = getSmallestFromFloorX(newCombs, element.floor);

        const smallestDesignNewMethod = getSmallestFromFloorX(
          newNewCombs,
          element.floor
        );

        console.log("Smallest with new calcs is ", smallestDesignNewMethod);

        //console.log("Smallest from this floor is ", smallestDesign);

        smallestDesigns.push(smallestDesignNewMethod);
      }
    });
    setTemp1(temp1);
    setTemp2(temp2);
    setOptimalDesigns(smallestDesigns);

    console.log("Optmial designs are ", optimalDesigns);

    // 3rd opmtimization
    const smallestBuildingValue = getMinFromBuilding(buildingLevelValuesSecondStage);
    let correspondingFloors = [];
    floorLevelValuesSecondStage.forEach((floor) => {
      const correspondingFloor = floor.combinations.find(
        (obj) => obj.id == smallestBuildingValue.id
      );
      addDescriptionToDesignGroup(correspondingFloor);
      correspondingFloor.floor = floor.floor;
      correspondingFloors.push(correspondingFloor);
    });
    console.log("conctant concrete are ", correspondingFloors);
    setConstantConcreteOptimization(correspondingFloors);
    setIsLoading(false);
    setShowTable(true);
  };

  const getSmallestFromFloorX = (combinations, floor) => {
    const smallestDesign = combinations.reduce(
      (designWithMinItotal, currentDesign) => {
        const minITotal = parseFloat(designWithMinItotal.iTotal);
        const currentItotal = parseFloat(currentDesign.iTotal);

        if (currentItotal < minITotal) {
          return currentDesign;
        } else {
          return designWithMinItotal;
        }
      }
    );
    smallestDesign.floor = floor;
    return smallestDesign;
  };

  if (isLoading) {
    return <Spin size="large" tip="Optimizing .." />;
  }

  const handleNext = () => {
    carouselRef.current.next();    
  };
  const handlePrevious = () => {
    carouselRef.current.prev();    
  };

  return (
    <div>
      {showTable && (
        <div>
          <div>
            <Title level={5} style={{ textAlign: "left" }}>
              Smallest design from floor one
            </Title>
            <br />
            <TempTable dataSource={[optimalFloorOne]} />
          </div>
          <div>
            <Title level={5} style={{ textAlign: "left" }}>
              Temp table 1
            </Title>
            <br />
            <Carousel ref={carouselRef}>
              {temp1.map((obj, index) => (
                <div>
                  <TempTable dataSource={obj} />
                </div>
              ))}
            </Carousel>
          </div>
          <div>
            <Title level={5} style={{ textAlign: "left" }}>
              Temp table 2
            </Title>
            <br />
            <Carousel>
              {temp2.map((obj, index) => (
                <div>
                  <TempTable dataSource={obj} />
                </div>
              ))}
            </Carousel>
          </div>
          <div>
            <Title level={5} style={{ textAlign: "left" }}>
              Optimized design to use fixed column geometries across every floor
              in the building
            </Title>
            <br />
            <OptimizedSummary dataSource={optimalDesigns} />
          </div>
          <div>
            <Title level={5} style={{ textAlign: "left" }}>
              Optimized design to use fixed mixed design
            </Title>
            <br />
            <OptimizedSummary dataSource={constantConcreteOptimization} />
          </div>
        </div>
      )}
    </div>
  );
};

export default FixedColumnsSecondStage;

